import PropTypes from 'prop-types';
import { LoadingDotsWrapper } from './styled';
import { Spin } from 'antd';
import { formatClassNames } from '../../../helpers';
import DynamicInvalidEntryModal from '../../DynamicInvalidEntryModal/DynamicInvalidEntryModal';
import React, { useState, useRef, Fragment, useEffect } from 'react';
import moment from 'moment';

const NewHourInput = (props) => {
  const MAX_HOURS = 15;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const previousValue = useRef();

  const [loading, setLoading] = useState(false)
  const [hours, setHours] = useState(props.entry.hours ?? 0)
  const canEdit = moment(props.date).isSameOrAfter(moment(), 'month');

  useEffect(() => {
    setHours(props.entry.hours ?? 0);
  }, [props.entry.hours]);


  const handleFocus = (e) => {
    e.target.select();
    previousValue.current = e.target.value;
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setHours(value);
    validateInput(value);
  };

  const handleBlur = (e) => {
    let { value } = e.target;
    if (!value || value.trim() === '') { // handle edge case: user hits space or other combo that gives us empty or all whitespace str - set 0
      value = 0;
    }

    if (value >= 0 && (value <= MAX_HOURS && (value % 1 === 0.5 || value % 1 === 0))) {
      setLoading(true);

      const newHours = Number(value);
      setHours(newHours);
            
      const updatedEntry = { ...props.entry, hours: newHours}

      props.handleInputChange({entry: updatedEntry, date: props.date, previousValue: previousValue.current, newValue: newHours}, () => {
        setLoading(false);
      }, resetValue);
    } else {
      if (value && value.trim() === '.') { // handle edge case: if user enters decimal and leaves field
        setHours(Number(previousValue.current));
      }
    }
  };

  const resetValue = () => {
    setHours(previousValue.current);
  };

  const validateInput = (value) => {
    let msg = '';
    if (value && (value > MAX_HOURS)) {
      msg = 'Hours should not exceed 15';
      setIsModalVisible(true);
    }
    else if (value && (value < 0)) {
      msg = 'Hours cannot be negative';
      setIsModalVisible(true);
    }
    else if (value && (typeof (value) === 'string') && isNaN(value) && value !== '.') {
      msg = 'Hours must be a number';
      setIsModalVisible(true);
    }
    else if (value && (value % 1 !== 0 && value % 1 !== 0.5 && value !== '.')) {
      msg = 'Hour entry must be in increments of 0.5';
      setIsModalVisible(true);
    }
    setErrMsg(msg);
    if (!isModalVisible && value) {
      setHours(value);
    }
  };

  const handleModalClose = () => {
    setHours(previousValue.current);
    setIsModalVisible(false);
  };
  return (
    <Fragment>
      {!loading ? (
        <input 
          key={props.date}
          type='text'
          inputMode='decimal'
          value={hours}
          id={props.date}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={!props.editable || !canEdit}
          className={formatClassNames(['hours__input', props.scheduled && 'scheduled'])}
        />
      ) : (
        <LoadingDotsWrapper>
          <Spin />
        </LoadingDotsWrapper>
      )}
      {isModalVisible && (
        <DynamicInvalidEntryModal
          closePopUp={() => handleModalClose()}
          date={new Date(props.date)}
          errorMessage={errMsg}
        />
          
      )}
      
    </Fragment>
  )
}

NewHourInput.propTypes = {
  entry: PropTypes.object,
  date: PropTypes.string,
  editable: PropTypes.bool,
  handleInputChange: PropTypes.func,
}

export default NewHourInput;